import styled from 'styled-components';
import { baseTheme } from '../../global/styles/theme';

export const RXGatePageContainer = styled('div')`
  width: 80%;
  margin: 0 auto;
  padding: 16px;
  height: fit-content;
  min-height: calc(100vh - 200px);
  position: relative;
  border: 1px solid ${baseTheme.colors.mainLightBlue};
  display: flex;
  flex-direction: column;
  gap: 10px;

  .form-container {
    width: fit-content;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .form-block {
      height: 30px;
      display: flex;
      align-items: center;
      gap: 10px;
      width: 100%;
      justify-content: space-between;

      .label {
        white-space: nowrap;
      }
      input {
        width: 100%;
      }

      .input-error {
        border: 2px solid red;
      }
    }

    .validation-error {
      margin: 0;
      color: red;
    }
  }

  @media only screen and (max-width: 550px) {
    padding: 0;
  }
`;

export const ScanButton = styled.button`
  cursor: pointer;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background-color: ${baseTheme.colors.mainLightBlue};
  border-radius: 8px;
  border: none;
  font-size: 14px;
  padding: '0px 10px';
  color: ${baseTheme.colors.white};
`;

export const ApplyRecipeButton = styled.button`
  cursor: pointer;
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background-color: ${baseTheme.colors.mainLightBlue};
  border-radius: 8px;
  border: none;
  font-size: 14px;
  padding: '0px 10px';
  color: ${baseTheme.colors.white};
`;

export const RecipeInfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;

  .recipe-info-block {
    width: 100%;
    height: 100%;
    border: 1px solid ${baseTheme.colors.mainLightBlue};
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .recipe-info {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: flex-start;
      align-content: flex-start;
      .recipe-info-item {
        width: 48%;
        height: fit-content;
        margin: 0;
      }
    }
  }
`;
